import EmailTemplate from '../../common/NotificationCenterShared/EmailTemplate'

const AgreementSignedConfirmationTemplate = () => {
  return (
    <>
    <EmailTemplate title='Email Agreement To Sign Confirmation'
    subTitle='Edit the template using the placeholders on the right.'
    templateFor='agreement_signed_confirmation'
    />
    </>
  )
}

export default AgreementSignedConfirmationTemplate